import { TrInputComponent } from './../tr-input/tr-input.component';
import { Component, ElementRef, Renderer2, AfterViewInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../interfaces/app-state.interface';

@Component({
    selector: 'tr-number',
    templateUrl: './tr-number.component.html',
})
export class TrNumberComponent extends TrInputComponent {

    @ViewChild('formInput', {static: true}) public formInput: ElementRef;

    constructor(
        private render: Renderer2,
        store: Store<AppState>,
    ) {
        super(store);
    }

    public onKeydown(event: any) {
        if (event.target.value.length >= this.maxLength
            && event.keyCode !== 8
            && event.keyCode !== 9
            && event.keyCode !== 46) return false;
    }

}
